// default
import { getDefaultState } from './default'

// types
import {
  USER_CLEAR_MODULE,
  USER_UPDATE_ROUTES,
  USER_SET_ROLE,
  USER_UPDATE_IS_COMPANYADMIN,
  USER_UPDATE_IS_SUPERADMIN,
  USER_UPDATE_IS_SELFCAREADMIN,
  USER_UPDATE_SINISTERS,
  USER_SET_MODE,
  USER_REDUX_MODE,
  USER_UPDATE_IS_MIX_ENABLE
} from '@/store/types'

export default {
  [USER_CLEAR_MODULE] (state) {
    Object.assign(state, getDefaultState())
  },
  [USER_UPDATE_ROUTES] (state, payload) {
    state.routes = payload
  },
  [USER_SET_ROLE] (state, payload) {
    state.role = payload
  },
  [USER_UPDATE_IS_COMPANYADMIN] (state, payload) {
    state.isCompanyAdmin = payload
  },
  [USER_UPDATE_IS_SUPERADMIN] (state, payload) {
    state.isSuperAdmin = payload
  },
  [USER_UPDATE_IS_SELFCAREADMIN] (state, payload) {
    state.isSelfcareAdmin = payload
  },
  [USER_UPDATE_SINISTERS] (state, payload) {
    state.userSinisters = payload
  },
  [USER_SET_MODE] (state, payload) {
    state.isReduxMode = payload === USER_REDUX_MODE
  },
  [USER_UPDATE_IS_MIX_ENABLE] (state, payload) {
    state.isMixEnabled = payload
  }
}
